<template>
  <v-toolbar app color="primary" dark fixed>
    <v-toolbar-title>
      <v-toolbar-side-icon @click="handleDrawerToggle"></v-toolbar-side-icon>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-menu
        :nudge-bottom="14"
        class="elelvation-1"
        offset-y
        origin="center center"
        transition="scale-transition"
        v-if="sessionUser.ROLE == 'GEM' || sessionUser.ROLE == 'ADM'"
      >
        <v-btn
          @click="$router.push('/notificaciones')"
          flat
          icon
          round
          slot="activator"
        >
          <v-badge color="red" overlap>
            <span slot="badge">{{ notificationsTotal }}</span>
            <v-icon medium>notifications</v-icon>
          </v-badge>
        </v-btn>
      </v-menu>
      <v-menu
        :nudge-bottom="10"
        offset-y
        origin="center center"
        transition="scale-transition"
      >
        <v-btn v-if="isLoggedIn" flat icon large round slot="activator">
          <v-avatar color="#bd614d" size="40px">{{
            sessionUser.ROLE
          }}</v-avatar>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile
            :disabled="item.disabled"
            :href="item.href"
            :key="index"
            :target="item.target"
            :to="!item.href ? { name: item.name } : null"
            @click="item.click"
            rel="noopener"
            ripple="ripple"
            v-for="(item, index) in items"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppToolbar',
  props: {
    notificationsTotal: Number,
  },
  data() {
    return {
      items: [
        {
          icon: 'fullscreen_exit',
          href: '#',
          title: 'Salir',
          click: this.handleLogut,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('session', {
      isLoggedIn: 'isLoggedIn',
      sessionUser: 'sessionUser',
    }),
  },
  methods: {
    handleDrawerToggle() {
      this.$emit('side-icon-click')
    },
    handleLogut() {
      this.$store.dispatch('session/logout').then(() => {
        location.href = '/auth/login'
      })
    },
  },
}
</script>

<style lang="css">
.v-list__group__items {
  background-color: #e7e7e7;
}
</style>
